import Cookies from 'js-cookie'
import Lightbox from './Lightbox'

export const inizializzaBannerSconto = {
  el: document.querySelector('#lightbox-course-discount'),

  init: function () {
    if (this.el) {
      this.el.classList.add('is-open')
    }
  }
}

export const inizializzaBannerCookie = {
  el: document.querySelector('.js-cookie-bar'),

  onTransitionEnd: function () {
    this.el.remove()
  },

  interactionListener: function () {
    Cookies.set('cookie', 'true', { expires: 30 })
    this.el.addEventListener('transitionend', this.onTransitionEnd)
    this.el.classList.remove('is-open')
    document.body.removeEventListener('click', this.interactionListener)
  },

  init: function () {
    if (this.el) {
      this.interactionListener = this.interactionListener.bind(this)
      this.onTransitionEnd = this.onTransitionEnd.bind(this)
      
      if (!Cookies.get('cookie')) {
        this.el.classList.add('is-open')
        document.body.addEventListener('click', this.interactionListener)
      } else {
        this.el.remove()
      }
    }
  }
}


// WEBPACK FOOTER //
// app/javascript/scripts/components/Altro.js